import { Component, OnInit } from '@angular/core';
import { LS_LANG, BASE_HREF, DEFAULT_LANG, OPTIONAL_LANG, LINKS_EXTERNAL, STORAGE } from 'src/app/core/utils/constants';
import { AuthenticationService } from 'src/app/core/auth/authentication.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HomeExternalService } from 'src/app/container/external/shared/home/home-external.service';
import { AccesoExternalService } from 'src/app/container/external/shared/acceso/acceso-external.service';
import { Utils } from 'src/app/core/utils/utils';
import * as _ from 'lodash';

@Component({
  selector: 'app-preheader',
  templateUrl: './preheader.component.html',
  styleUrls: ['./preheader.component.scss']
})
export class PreheaderComponent implements OnInit {

  usuario: string = "";

  /** Rutas a la imagen del logo precabezera */
  readonly LOGO_PREHEADER: String = BASE_HREF + 'assets/images/ajuntament-de-reus.png';
  readonly LOGO_PREHEADER_RESPON: String = BASE_HREF + 'assets/images/ajuntament-de-reus-responsive.png';
  //readonly LOGO_PROMOCION: String = BASE_HREF + 'assets/images/grid-promocio.png';
  //readonly LOGO_CULTURA: String = BASE_HREF + 'assets/images/grid-capital.png';
  //readonly LOGO_REDES: String = BASE_HREF + 'assets/images/share.png';

  /**rutas externas a webs y servicios de Reus */
  readonly REUS: String = LINKS_EXTERNAL.REUS;
  readonly REUS_TURISMO: String = LINKS_EXTERNAL.REUS_TURISMO;
  readonly REUS_CULTURA: String = LINKS_EXTERNAL.REUS_CULTURA;
  readonly REUS_REDES: String = LINKS_EXTERNAL.REUS_REDES;

  readonly CA = DEFAULT_LANG;
  readonly ES = OPTIONAL_LANG;

  constructor(private authService: AuthenticationService,
              private translateService: TranslateService,
              private homeExternalService : HomeExternalService,
              private accesoExternalService: AccesoExternalService,
              private router: Router) { }

  ngOnInit() {
    this.obtenerUsuario();
    Utils.changeStyleTranslate();
  }

  /**
  * @description
  * Obtenemos el nombre del usuario
  */
  public obtenerUsuario() {
    this.usuario = this.authService.getUsername();
  }

  /**
  * @description
  * Se cambia el idioma de la aplicación.
  * Se guarda el idioma seleccionado en el almacenamiento local y se recarga la página. Desde app.component se recuperará seleccionado el idioma al recargar la pantalla
  * @param lang
  */
  public changeLang(lang: string) {
    switch(location.pathname) {
      case "/external/passarela/home": 
      case "/external/empreses/home":
      case "/external/proveidors/home":{
        this.homeExternalService.refrescoHeader = true;
        this.translateService.setDefaultLang(lang);
        this.translateService.use(lang);
        localStorage.setItem(LS_LANG, lang);
        Utils.changeStyleTranslate();
        this.homeExternalService.refrescar(localStorage.getItem(STORAGE.DBOID));
        break;
      }
      case "/external/passarela/acces":
      case "/external/empreses/acces":
      case "/external/proveidors/acces":{
        this.translateService.setDefaultLang(lang);
        this.translateService.use(lang);
        localStorage.setItem(LS_LANG, lang);
        Utils.changeStyleTranslate();
        this.accesoExternalService.gestionRedirecIdioma();
        this.accesoExternalService.idioma = _.cloneDeep(lang);
        break;
      }
      default: {
        localStorage.setItem(LS_LANG, lang);
        location.reload();
        break;
      }
    }
  }

  /**
  * @description
  * Salimos de la aplicación (actualmente en desuso)
  */
  public logout() {
    this.authService.doLogout().subscribe(result => {
      this.router.navigate(['/external/acces']);
    },error => {
      console.log(error);
      this.router.navigate(['/pagina-error']);
    });
  }

  /**
  * @description
  * Activar o desactivar Elemento buscadorAccion (actualmente en desuso)
  */
  public buscadorAccion() {

    var y = document.getElementById("capital-cultural-reus");
    var x = document.getElementById("expand-searcher-reus");
    if(y && x){
      y.style.display = "none";

      if (x.style.display === "block") {
          x.style.display = "none";
      } else {
          x.style.display = "block";

      }
    }
  }

  /**
  * @description
  * Activar o desactivar Elemento gridAccion (actualmente en desuso)
  */
  public gridAccion() {
    
    var y = document.getElementById("capital-cultural-reus");
    var x = document.getElementById("expand-searcher-reus");
    
    if(y && x){
      x.style.display = "none";

      if (y.style.display === "block") {
          y.style.display = "none";
      } else {
          y.style.display = "block";
        
      }
    }
  }

}
